import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';

interface LenderInvitePageActionButtonProps {
	onSearchLender: () => void;
	onTeaserPreview: (preview: boolean) => void;
	onEditSummary: (bool: boolean) => void;
}

type LenderInvitePageActionItem = keyof typeof LenderInvitePageActionItemMap;
const LenderInvitePageActionItemMap = {
	EmailPreview: 'Email Preview',
	EditSummaryText: 'Edit Summary Text',
	SearchLender: 'Search For Lender',
};

export const LenderInvitePageActionButton: React.FC<LenderInvitePageActionButtonProps> = ({
	onSearchLender,
	onTeaserPreview,
	onEditSummary,
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: LenderInvitePageActionItem) => {
		switch (action) {
			case 'EmailPreview':
				onTeaserPreview(true);
				break;
			case 'EditSummaryText':
				onEditSummary(true);
				break;
			case 'SearchLender':
				onSearchLender();
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: LenderInvitePageActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Invite Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu" autoFocusItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'SearchLender')}>
										{LenderInvitePageActionItemMap['SearchLender']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'EmailPreview')}>
										{LenderInvitePageActionItemMap['EmailPreview']}
									</MenuItem>
									<MenuItem onClick={event => handleMenuItemClick(event, 'EditSummaryText')}>
										{LenderInvitePageActionItemMap['EditSummaryText']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
